module.exports = __webpack_public_path__ + "img/ico_ph59-.f39c5187.svg";